import * as lib from 'Root/lib/lib.js'

const ACTIVE_CLASS = 'is-open'

class VideoModal {
    constructor(element) {
        if (!element) return

        this.element = $(element)
        this.videoWrap = this.element.find('.s-video-modal__video')
        this.closeBtn = this.element.find('.s-video-modal__close')

        this._iniEvents()
    }

    _iniEvents() {
        const self = this
        this.modalTriggerElem = $(`[data-modal-trigger="${this.element.attr('id')}"]`)

        if (this.modalTriggerElem.length) {
            this.modalTriggerElem.on('click', () => {
                this.open()
            })
        }

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.s-video-modal__video').length && self.element.hasClass(ACTIVE_CLASS)) {
                self.close()
            }
        })

        $(document).on('keyup', (e) => {
            if (e.key === 'Escape') {
                this.close()
            }
        })

        this.closeBtn.on('click', () => {
            self.close()
        })
    }

    open() {
        const iframe = `
            <iframe
                src="https://www.youtube-nocookie.com/embed/${this.element.attr(
                    'data-video-id'
                )}?si=bWw5alFq-djNMrSy&amp;controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
            </iframe>
        `
        this.videoWrap.html($(iframe))

        lib.disableBodyScroll()

        this.element.fadeIn(300)

        setTimeout(() => {
            this.element.addClass(ACTIVE_CLASS)
        })
    }

    close() {
        lib.enableBodyScroll()

        this.element.fadeOut(400, () => {
            this.videoWrap.html('')
        })
        this.element.removeClass(ACTIVE_CLASS)
    }
}

export default VideoModal
